import React, { useState, useEffect, useContext } from 'react';
import { TfiMenuAlt } from 'react-icons/tfi';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { GoSearch } from 'react-icons/go';
import "./css/Leads.css"
import axios from "axios"
import AddLead from '../components/AddLead';
import { useNavigate } from 'react-router-dom';
import { Box, Button, IconButton, Modal } from '@mui/material';
import { Link, Outlet } from 'react-router-dom';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import api from "../config/backend";
import search from '../assets/icons/search.svg';
import pdf from '../assets/icons/pdf.svg';
import filter from '../assets/icons/filter.svg';
import upload from '../assets/icons/upload.svg';
import leadslist from '../assets/icons/leads-list.svg';
import leadstable from '../assets/icons/leads-table.svg'

const Leads = (props) => {
    const [triggerRefresh, setTriggerRefresh] = useState(0)

    const [searchLead, setSearchLead] = useState("")
    const [isSearchLeadVisible, setIsSearchLeadVisible] = useState(false)
    const navigate = useNavigate()

    console.log(props)


    const [Leadsdata, setLeadsdata] = useState([])
    console.log(Leadsdata)
    const token = localStorage.getItem("_crm__token")

    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const fetchLeads = async () => {
        const { data, status } = await axios.post(`${api}/Leads/fetch-leads`, { token, view: "list" })
        console.log({ data })
        if (data.success) {
            setLeadsdata(data)
        } else {
            console.log({ data })
        }
    }

    useEffect(() => {
        fetchLeads()
    }, [])



    return (
        <div className='app-new-leads'>
            <div className="sub-nav">
                <div className='sub-nav__left'>
                    <div className='sub-nav__toggles'>
                        <Link to='/leads/leads-view'>
                            <img src={leadstable} />
                        </Link>
                        <Link to='/leads/leads-pipe-view'>
                            <img src={leadslist} />
                        </Link>
                    </div>
                </div>
                <div className='sub-nav__right'>
                    <div className='sub-nav__buttons sub-nav__buttons2'>

                        {isSearchLeadVisible ?
                            <input
                                className='input-search'
                                onMouseEnter={() => setIsSearchLeadVisible(true)}
                                onMouseLeave={() => setIsSearchLeadVisible(false)}
                                value={searchLead}
                                onChange={e => setSearchLead(e.target.value)}
                                type="text"
                                placeholder="Search By Name"
                                style={{
                                    border: '1px solid #ccc', 
                                    padding: '5px', 
                                    borderRadius: '4px' ,
                                    marginRight:'4px'
                                }}
                            />
                            : undefined
                        }


                        <a href="#" class="search-btn" onMouseEnter={() => setIsSearchLeadVisible(true)} onMouseLeave={() => setIsSearchLeadVisible(false)}>
                            {/* <i class>="fas fa-search"></i> */}
                            <img src={search} />
                        </a>
                    </div>
                    {/* <div className='sub-nav__buttons'>
                        <Button variant="contained" className='app-btn app-new-btn'><img src={pdf}/></Button>
                   </div>
                    <div className='sub-nav__buttons'>
                        <Button variant="contained" className='app-btn app-new-btn'><img src={filter}/></Button>
                   </div> */}
                    {/* <div className='sub-nav__buttons'>
                        <Button variant="contained" className='app-btn app-new-btn app-new-btn2'><img src={upload}/>Upload</Button>
                   </div> */}
                    <div className='sub-nav__buttons'>
                        <Button variant="contained" className='app-btn app-new-btn app-new-btn3' onClick={handleClickOpen}><AddRoundedIcon />New lead</Button>

                        {open && (
                            <AddLead isPopup={open} setPopup={setOpen} setTriggerRefresh={setTriggerRefresh} />
                        )}

                    </div>
                </div>
            </div>
            <div className='main-body'>
                <Outlet context={[triggerRefresh, setTriggerRefresh, searchLead]} />
            </div>


        </div >
    );
};

export default Leads;
